<script setup lang="ts">
import { onBeforeMount } from "vue";
import { useI18n } from "vue-i18n";

import FocusedMessage from "@/components/FocusedMessage.vue";

const { t } = useI18n();

onBeforeMount(() => {
  window.close();
});
</script>

<template>
  <FocusedMessage>
    <template #message>{{ t("iframe.self-closing-window.message") }}</template>
  </FocusedMessage>
</template>
